"use strict";
/* eslint no-sync: 0 */

import angular from "angular";

export class NavbarComponent {
  menu = [
    {
      title: "Home",
      state: "main"
    },
    {
      title: "Dashboard",
      state: "dashboard"
    },
    {
      title: "Incident",
      state: "incident"
    }
  ];

  isCollapsed = true;
  VERSION;
  showMenu = false;

  constructor(Auth, appConfig, $rootScope, $uibModal) {
    "ngInject";

    this.VERSION = appConfig.VERSION;
    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.isHccAdmin = Auth.isHccAdminSync;
    this.isUser = Auth.isUserSync;
    this.isOpAdmin = Auth.isOpAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$uibModal = $uibModal;

    $rootScope.$on("$stateChangeSuccess", () => {
      this.showMenu = false;
    });
  }

  startIncident() {
    this.$uibModal.open({
      animation: true,
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: require("../../app/incident/addIncident.html"),
      controller: "AddIncidentController",
      controllerAs: "$ctrl"

      // appendTo: parentElem,
      // resolve: {
      //   items: function () {
      //     return $ctrl.items;
      //   }
      // }
    });
  }
}

export default angular.module("directives.navbar", []).component("navbar", {
  template: require("./navbar.html"),
  controller: NavbarComponent
}).name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js